<template>
  <div>
    <mt-header fixed :title="getOkTitle" class="title2">
      <mt-button slot="left" icon="back" @click="handleBackClick">返回</mt-button>
      <mt-button slot="right" @click="handleMoreBtnClick">更多</mt-button>
    </mt-header>
    <div>
      <mt-navbar v-model="active">
        <mt-tab-item :id="1">日业绩</mt-tab-item>
        <mt-tab-item :id="2">月业绩</mt-tab-item>
      </mt-navbar>
      <mt-tab-container v-model="active">
        <mt-tab-container-item :id="1">
          <detailed-list-examine v-if="isExamine" ref="detail1" :flag="flag" :mark="1" :actived="active" />
          <detailed-list v-else ref="detail1" :flag="flag" :mark="1" :actived="active" />
        </mt-tab-container-item>
        <mt-tab-container-item :id="2">
          <detailed-list-examine v-if="isExamine" ref="detail2" :flag="flag" :mark="2" :actived="active" />
          <detailed-list v-else ref="detail2" :flag="flag" :mark="2" :actived="active" />
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_JUMP_FLAG,PUBLIC_IS_EXAMINE */

import DetailedList from '@/components/DetailedList.vue';
import DetailedListExamine from '@/components/DetailedListExamine.vue';

export default {
  name: 'Detailed2',
  components: {
    DetailedList,
    DetailedListExamine,
  },
  data() {
    return {
      title: '业绩',
      active: 1,
      flag: PUBLIC_JUMP_FLAG,
      isExamine: PUBLIC_IS_EXAMINE,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'overview') {
      this.$store.commit('setCache', 'Detailed2');
    } else {
      this.$store.commit('delCache', 'Detailed2');
    }
    next();
  },
  computed: {
    getOkTitle() {
      switch (this.flag) {
        case '0':
          return '汇总业绩';
        case '1':
          return '个人业绩';
        case '2':
          return '代理业绩';
        default:
          return '汇总业绩';
      }
    },
  },
  methods: {
    handleMoreBtnClick() {
      if (this.active === 1) this.$refs.detail1.openDatePicker();
      else if (this.active === 2) this.$refs.detail2.openDatePicker();
    },
    handleBackClick() {
      window.location.href = 'protocol://android';
    },
  },
};
</script>
